module.exports = __webpack_public_path__ + "img/google play.482e161.svg";